import { useState } from 'react';
import styles from './InfoButton.module.scss';
import { AppName } from '../consts';

interface InfoButtonProps {
  scene?: 'MyRoom' | 'CardCase';
}

const InfoButton = ({ scene = 'MyRoom' }: InfoButtonProps) => {
  const [isPopoverVisible, setIsPopoverVisible] = useState(false);

  const handleInfoButtonClick = () => {
    setIsPopoverVisible(!isPopoverVisible);
  };

  const handleOverlayClick = () => {
    setIsPopoverVisible(false);
  };

  return (
    <>
      {isPopoverVisible && (
        <div className={styles.overlay} onClick={handleOverlayClick} />
      )}
      
      <div className={styles.infoButtonContainer}>
        <button 
          className={styles.infoButton}
          onClick={handleInfoButtonClick}
          aria-label="Information"
        >
          <svg 
            className={styles.infoIcon}
            viewBox="0 0 24 24" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
            <path d="M12 16v-4" stroke="currentColor" strokeWidth="2"/>
            <path d="M12 8h.01" stroke="currentColor" strokeWidth="2"/>
          </svg>
        </button>
        
        {isPopoverVisible && (
          <div className={styles.popover}>
            <div className={styles.popoverContent}>
              <h3 className={styles.popoverTitle}>操作方法</h3>
              <ul className={styles.popoverList}>
                {
                  scene === 'MyRoom' ? (
                    <>
                      <li>色のついたオブジェクトにはイベントがあります。※ギターはPCのみ。</li>
                      <li>PCでは、ギターを振り回すことができます。</li>
                      <li>スマホでは、部屋を見まわせます。</li>
                    </>
                  ) :
                  scene === 'CardCase' ? (
                    <>
                      <li>名刺をクリックしてください。</li>
                    </>
                  ) : (<></>)
                }
              </ul>
              <div className={styles.popoverFooter}>
                <p className={styles.portfolioInfo}>
                  {AppName}
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default InfoButton;
